import { isJourneyReport, isRelationalReport } from '../tsTypes/reportTypes';
export const isReportResolveObject = reportResolve => {
  return reportResolve && reportResolve.configured !== undefined && reportResolve.data !== undefined && reportResolve.hasData !== undefined;
};
export const getReportDatasetFromReportResolve = (report, reportResolve) => {
  let dataset;
  if (!reportResolve) {
    return;
  } else if (isRelationalReport(report)) {
    dataset = reportResolve;
  } else if (isJourneyReport(report)) {
    dataset = reportResolve === null || reportResolve === void 0 ? void 0 : reportResolve.getIn(['resolveDatamap', 'primary']);
  } else {
    var _data;
    dataset = reportResolve === null || reportResolve === void 0 || (_data = reportResolve.data) === null || _data === void 0 ? void 0 : _data.getIn(['primary', 'data']);
  }
  return dataset;
};